


import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { ButtonComponent } from '@components/button/button.component'
import { AlertComponent } from '@components/alert/alert.component'
import { BadgeStatusComponent } from '@components/badge-status/badge-status.component'
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component'
import { SlickCarouselModule } from 'ngx-slick-carousel'
import { AccountType } from '../../../interfaces/api/AccountType'
import { ApiService, UserInfo } from '../../../services/api.service'
import { Router } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { environment } from '../../../../environments/environment'
import { LanguageParserService } from '../../../services/language-parser.service'
import { SalesforceService } from '../../../services/salesforce.service'

@Component({
    selector: 'app-samples-card',
    templateUrl: './samples-card.component.html',
    styleUrl: './samples-card.component.scss',
    standalone: true,
    imports: [TranslateModule, ButtonComponent, AlertComponent, CommonModule, BadgeStatusComponent, CosentinoSvgComponent, SlickCarouselModule, FormsModule],
    encapsulation: ViewEncapsulation.None,
})
export class SamplesCardComponent implements OnInit {
    @Input() sample: any
    @ViewChild('nameInput') nameInput!: ElementRef // Reference to the input element
    userInfo: UserInfo
    editNameMode: boolean = false;
    tempName: string = '';
    isSaving: boolean = false; // Bandera para evitar conflictos entre blur y click
    protected readonly AccountType = AccountType
    @Output() clickCustom = new EventEmitter()

    constructor(
        private api: ApiService,
        private router: Router,
        private translate: TranslateService,
        private languageParser: LanguageParserService,
        private canvas: SalesforceService
    ) {}

    ngOnInit() {
        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))

        console.log(AccountType.isCtop(this.userInfo.accountType) ? 'Ctop user' : 'Non-Ctop user')
    }

    continueOrAddMore(sample: any) {
        const lang = this.languageParser.getShortLanguage(this.userInfo?.locale)
        const samplesUrl = `${environment.samplesEndpoint}?language=${lang}`
        if(this.canvas.isCanvas() && window.top){
            window.top.postMessage({
                type: "navigateTo",
                communityPage: "",
                externalUrl: samplesUrl,
                params: "",
                newTab: false
            }, environment.salesforceUrl);
        } else {
            window.location.href = samplesUrl;
        }
    }

    onViewDetails() {
        this.router.navigate(['/my-samples/sample-detail/', this.sample.id])
    }

    /**
     * Devuelve el estado de la muestra según la lógica de negocio (ver documentacion)
     */
    getStatus(): 'draft' | 'inprogress' | 'indelivery' | 'delivered' | 'error' {
        const s = this.sample

        // Caso 1: Draft
        if (s.status === 'Pending') return 'draft'

        // Caso 2: In progress
        if (s.status === 'Activated') return 'inprogress'

        // Caso 3: In progress
        if (s.status === 'Preparing' && s.shippingType === 'Logistic provider') return 'inprogress'

        // Caso 4: In progress
        if (s.status === 'Preparing' && s.shippingType === 'Business visit') return 'inprogress'

        // Caso 6: In delivery
        if (s.status === 'Sent' && s.shippingType === 'Logistic provider') return 'indelivery'

        // Caso 6: Delivered
        if (s.status === 'Delivered') return 'delivered'

        // Default: cualquier otro estado (incluyendo 'Rejected') se considera error.
        return 'error'
    }

    getStatusBadgeLabel(): string {
        switch (this.getStatus()) {
            case 'draft':
                return this.translate.instant('order_samples.draft')
            case 'inprogress':
                return this.translate.instant('order_samples.inprogress')
            case 'indelivery':
                return this.translate.instant('order_samples.indelivery')
            case 'delivered':
                return this.translate.instant('order_samples.delivered')
            case 'error':
                return this.translate.instant('order_samples.error')
            default:
                return ''
        }
    }

    
    getSampleStatusForGtm(): 'draft' | 'in-progress' | 'in-delivery' | 'delivered' | 'error' {
        const s = this.getStatus();

        switch (s) {
            case 'draft':
                return 'draft';
            case 'inprogress':
                return 'in-progress';
            case 'indelivery':
                return 'in-delivery'
            case 'delivered':
                return 'delivered'
            case 'error':
                return 'error'  
        }
    }

    getGtmLabelViewDetails(): string {
    const status = this.getSampleStatusForGtm();
    return `${status}_link_see-details`;
    }

    getStatusIconClass(): string {
        return this.getStatus()
    }

    onEditName() {
        this.tempName = this.sample.alias !== null ? this.sample.alias : this.sample.name;
        this.editNameMode = true;

        // Verifica si nameInput está definido antes de intentar acceder a nativeElement
        setTimeout(() => {
            if (this.nameInput) {
                this.nameInput.nativeElement.focus();
            }
        }, 100);
    }

    onSaveNameEdit(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.isSaving = true; // Indica que se está guardando
        this.saveNameEdit();
    }

    saveNameEdit() {
        if (this.tempName.trim() === '') {
            this.tempName = this.sample.name;
        }
        this.api.editSampleAlias(this.sample.id, this.tempName).subscribe(() => {
            this.editNameMode = false;
            this.sample.alias = this.tempName;
            this.isSaving = false; // Restablece la bandera después de guardar
        });
    }

    cancelNameEdit() {
        if (this.isSaving) return; // Evita cancelar si se está guardando
        this.editNameMode = false;
    }
}